
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Tik op "Openen in browser..."`,
's182ab2d6c997515f': `Zet het op je beginscherm voor een uitgebreide ervaring en gemakkelijke toegang.`,
's224cbcec014ef6b5': `Druk op delen in de navigatiebalk`,
's233af3b7eb5e0364': `Toevoegen aan startpagina`,
's37a9e8aec5713460': `Meer`,
's4c3161035f3a1413': `Druk op Menu`,
's4e1e10a6ca408245': `Tik op "Zet op beginscherm"`,
's6196153c4b0c1ea0': `Installeren`,
's633502f7cff4f847': `Open je browsermenu`,
's681e399d63311fba': `Galerij tonen`,
's6d14a4f70ba4e3cf': `Druk op Menu als er geen Deel-icoon is`,
's922329d6f6213590': `Toevoegen aan Dock`,
's9c63a79ffcc2a3a3': `Druk op "Zet op beginscherm"`,
'sa2d71bfd9525168d': `Druk op "Toevoegen aan Dock"`,
'sa5ef80b4bb9b39f8': `Minder`,
'sb527eca1c1d7e7be': `Open het menu van de in-appbrowser`,
'sba52286c21552a4e': `Installeer het op je apparaat voor een uitgebreide ervaring en gemakkelijke toegang.`,
'sc16e00a7a8b2fde2': `Terug`,
'scdaf4bbff76674c8': `Zet op beginscherm`,
'sd18a5b85f599ff3c': `Open de gekopieerde link in Safari`,
'se72fc3a84f9b51c3': `Tik om de link te kopiëren`,
'se740f75b95a51807': `Voeg het toe aan je Dock voor een uitgebreide ervaring en makkelijke toegang.`,
'sfa6c42cdf48d93d2': `Maar deze browser ondersteunt deze functie niet. Open de link in een externe browser om door te gaan.`,
'sfb78526365796a41': `Druk op "Bekijk meer" in het Deel-menu`,
'sfea652f6580ff086': `Deze site heeft app-functionaliteit.`,
    };
  